import statusMapping from './statusMapping';

const getStatusTitle = (statusConst) => {
    return statusMapping[statusConst] || statusConst;
};

export default getStatusTitle;